import { type Mapper } from '@coris-ts/repository/mapper/mapper'
import { type CashFlowItemEntity } from '../../data/entities/cash-flow.entity'
import { type CashFlowData, type CashFlowResponse } from '../models/cash-flow'

export class CashFlowEntityToCashFlowResponseMapper implements Mapper<CashFlowItemEntity[], CashFlowResponse> {
  public map(from: CashFlowItemEntity[]): CashFlowResponse {
    const data: CashFlowData[] = from.map((item) => ({
      month: item.date,
      monthlySubscriptions: item.monthly,
      yearlySubscriptions: item.yearly,
      fees: item.fees,
      tshirtCosts: item.t_shirts,
      refunds: item.refunds,
      net: item.total
    }))

    const currentMonth = data.length > 0 ? data[data.length - 1] : null

    return {
      data,
      currentMonth
    }
  }
}
